module.exports = __webpack_public_path__ + "static/media/telegram.0d5ee41e.png";